import React from "react";
import * as styledComponents from "./styles";
import AddItemIcon from "components/AddItem";
import HeadphoneIcon from "components/HeadphoneIcon";
import ShoppingBag from "components/ShoppingBag";
import { useHistory } from "react-router-dom";
import parse from "html-react-parser";
import { base } from "api/hosts";
interface DetailItemProps extends React.HTMLAttributes<Element> {
  item: any;
  addItemToCart: any;
  hiddenAdd?: any;
}

const DetailItem: React.FC<DetailItemProps> = ({
  item,
  addItemToCart,
  hiddenAdd,
}) => {
  const history = useHistory();
  const addItem = () => {
    addItemToCart(item);
  };

  const goToConsultation = () => {
    window.open("https://calendly.com/luisenriquecgongora");
  };

  const requestNow = () => {
    addItemToCart(item);
    history.push("/shop/cart");
  };

  console.log(item);
  return (
    <styledComponents.DetailItemContainer>
      hi
      <styledComponents.Title>
        {item.attributes.name.toUpperCase()}
      </styledComponents.Title>
      <styledComponents.Image
        src={`${base}${item.attributes.image.data.attributes.url}`}
      />
      <styledComponents.ContainerCallsToAction>
        {!hiddenAdd && (
          <styledComponents.ActionBellowImage onClick={goToConsultation}>
            SCHEDULE A CALL
            <HeadphoneIcon />
          </styledComponents.ActionBellowImage>
        )}
        {!hiddenAdd && (
          <styledComponents.ActionBellowImage onClick={addItem}>
            ADD TO CART
            <AddItemIcon />
          </styledComponents.ActionBellowImage>
        )}
      </styledComponents.ContainerCallsToAction>
      <styledComponents.Text>
        {parse(item.attributes.description || "")}
      </styledComponents.Text>
      <styledComponents.Subtitle>Benefits</styledComponents.Subtitle>
      <styledComponents.Text>
        {parse(item.attributes.benefits || "")}
      </styledComponents.Text>
      <styledComponents.Subtitle>Requirements</styledComponents.Subtitle>
      <styledComponents.Text>
        {parse(item.attributes.requirements || "")}
      </styledComponents.Text>
      <styledComponents.Subtitle>
        Terms and Conditions
      </styledComponents.Subtitle>
      <styledComponents.Text>
        {parse(item.attributes.termsConditions || "")}
      </styledComponents.Text>
      <styledComponents.Divider />
      <styledComponents.ContainerSum>
        {item.attributes.deliveryTime && (
          <styledComponents.ContainerDeliveryTime>
            Delivery Time <br />
            {item.attributes.deliveryTime}
          </styledComponents.ContainerDeliveryTime>
        )}
        <styledComponents.ContainerPrice>
          Price <br />€ {item.attributes.priceEUR}
        </styledComponents.ContainerPrice>
        {!hiddenAdd && (
          <styledComponents.CallToAction onClick={requestNow}>
            REQUEST NOW
            <ShoppingBag />
          </styledComponents.CallToAction>
        )}
      </styledComponents.ContainerSum>
      <styledComponents.Divider />
    </styledComponents.DetailItemContainer>
  );
};

export default DetailItem;
